import PatientSearchBox from "~/components/patient/PatientSearchBox";
import { MapPatientInfo } from "~/state/map/mapPatientInfo";

type PatientLocationSearchBoxProps = {
  mapPatientInfo: MapPatientInfo | null;
  loadingPatientInfo: boolean;
  setMapPatientId: (patientId: number | null) => void;
};

export const mapWidth = "calc(100vw - 60px)";
export const mapHeight = "calc(100vh - 330px)";

const PatientLocationSearchBox = ({
  mapPatientInfo,
  loadingPatientInfo,
  setMapPatientId,
}: PatientLocationSearchBoxProps) => {
  return (
    <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px", gap: "1rem" }}>
      <span>Show marker at patient location:</span>
      {mapPatientInfo ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          {mapPatientInfo.fullName}
          <button
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              setMapPatientId(null);
            }}
          >
            Clear
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <PatientSearchBox
            onPatientClicked={(patient) => {
              if (patient?.id) {
                setMapPatientId(patient.id);
              }
            }}
          />
          <div style={{ marginLeft: "1rem" }}>
            {loadingPatientInfo && <span>Loading patient location...</span>}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientLocationSearchBox;
